import zipwith from 'lodash.zipwith';

export const onTranslatehandler = (links = [], words = [], property = '', t, key = '') => {
  let translatedWords = zipwith(links, words, (link, word) => {
    return { ...link, [property]: t(`${key}${word}` || word) };
  });

  return translatedWords;
};
